import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { addOrderConditionsApi, deleteOrderConditionsApi, getOrderConditionsApi, updateOrderConditionsApi } from "../../../services/partners/settings/orderConditionsService";


export const getAllPartnerOrderConditions = createAsyncThunk("partner/getAllPartnerOrderConditions", async (filters, { dispatch }) => {
  const response = await getOrderConditionsApi(filters);
  return response.response;
});

export const addPartnerOrderConditions = createAsyncThunk("partner/addPartnerOrderConditions", async (duration, { dispatch, getState }) => {
  try {
    const response = await addOrderConditionsApi(duration);
    const data = await response.response;
    toast.success("Add Partner Return Cost Payers successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const updatePartnerOrderConditions = createAsyncThunk("partner/updatePartnerOrderConditions", async (duration, { dispatch, getStatus }) => {
  try {
    const response = await updateOrderConditionsApi(duration, duration.id);
    const data = await response.response;
    toast.success("Update Return Cost Slayers successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const deletePartnerOrderConditions = createAsyncThunk("partner/deletePartnerOrderConditions", async (id, { dispatch, getStatus }) => {
  try {
    const response = await deleteOrderConditionsApi(id);
    const data = await response.response;
    toast.success("Deleted Return Cost Payers successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

const partnersOrderConditionsAdapter = createEntityAdapter({});

export const { selectAll: selectPartnerOrderConditions, selectById: selectPartnerOrderConditionsId } = partnersOrderConditionsAdapter.getSelectors(
  (state) => state.partner.partnerOrderConditions
);

const partnerOrderConditionsSlice = createSlice({
  name: "partnerOrderConditions",
  initialState: partnersOrderConditionsAdapter.getInitialState({
    searchText: "",
    addDialog: {
      component: "PartnerOrderConditions",
      type: "new",
      props: {
        open: false,
      },
      data: null,
    },
  }),
  reducers: {
    setPartnerOrderConditionsSearchText: {
      reducer: (state, action) => {
        state.searchText = action.payload;
      },
      prepare: (event) => ({ payload: event.target.value || "" }),
    },
    openNewDialog: (state, action) => {
      state.addDialog = {
        component: "PartnerOrderConditions",
        type: "new",
        props: {
          isOpen: true,
        },
        data: null,
      };
    },
    openEditDialog: (state, action) => {
      state.addDialog = {
        type: "edit",
        props: {
          isOpen: true,
        },
        data: action.payload,
      };
    },
    closeEditDialog: (state, action) => {
      state.addDialog = {
        type: "edit",
        props: {
          isOpen: false,
        },
        data: null,
      };
    },
  },
  extraReducers: {
    [getAllPartnerOrderConditions.fulfilled]: partnersOrderConditionsAdapter.setAll,
  },
});

export const { setPartnerOrderConditionsSearchText, openNewDialog, closeNewDialog, openEditDialog, closeEditDialog } = partnerOrderConditionsSlice.actions;

export default partnerOrderConditionsSlice.reducer;
